import { render, staticRenderFns } from "./HostingServiceView.vue?vue&type=template&id=53145b9c&"
import script from "./HostingServiceView.vue?vue&type=script&lang=js&"
export * from "./HostingServiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53145b9c')) {
      api.createRecord('53145b9c', component.options)
    } else {
      api.reload('53145b9c', component.options)
    }
    module.hot.accept("./HostingServiceView.vue?vue&type=template&id=53145b9c&", function () {
      api.rerender('53145b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/HostingServiceView.vue"
export default component.exports